import Cookie from 'js-cookie';
import { success } from 'redux-saga-requests';
import * as ActionTypes from './actionTypes';

export const initialState = {
  isAuthenticated: Boolean(Number(Cookie.get('signed_in')))
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case success(ActionTypes.USER_SIGN_IN): {
      return {
        ...state
        // temp enable client-side redirect
        // isAuthenticated: true
      };
    }

    default: {
      return state;
    }
  }
}
